import {
  ButtonWrapper,
  CardButtonMedium,
  LocationOnOutlineMediumIcon,
  Section,
  Skeleton,
} from '@ferreri/prever-component-lib';
import { useRouter } from 'next/router';
import { useQueryClient } from '@ferreri/minato-react-utils';

import { LoactionSearchEmptyState } from './LocationSearchEmptyState';
import { usePersistedGeolocation } from '@modules/geolocation/geolocation.store';

type Item = {
  latitude: number;
  longitude: number;
  address: string;
};

type LocationListProps = {
  isEmpty?: boolean;
  isFetching?: boolean;
  items?: Item[];
};

const SkeletonLocationList = () => {
  return (
    <Section>
      <Skeleton width={'100%'} height={56} />
      <Skeleton width={'100%'} height={56} />
      <Skeleton width={'100%'} height={56} />
      <Skeleton width={'100%'} height={56} />
      <Skeleton width={'100%'} height={56} />
    </Section>
  );
};

export const LocationList = (props: LocationListProps) => {
  const router = useRouter();
  const queryClient = useQueryClient();
  const { setValue } = usePersistedGeolocation();

  if (props.isFetching) {
    return <SkeletonLocationList />;
  }

  if (props.isEmpty) {
    return <LoactionSearchEmptyState />;
  }

  return (
    <Section>
      {props.items?.map((item) => (
        <ButtonWrapper
          key={item.address}
          onClick={() => {
            setValue({
              address: item.address,
              latitude: item.latitude,
              longitude: item.longitude,
            });

            queryClient.invalidateQueries({
              queryKey: ['establishmentsIds'],
              exact: false,
            });

            router.push('/');
          }}
        >
          <CardButtonMedium
            title=""
            icon={<LocationOnOutlineMediumIcon />}
            description={item.address}
          />
        </ButtonWrapper>
      ))}
    </Section>
  );
};
